export function resolveForkEngineTheme(input) {
    const custom = input.crosshairColor?.trim();
    return {
        mode: input.mode,
        gridColor: input.gridColor,
        gridDash: input.gridDash,
        gridWidth: input.gridWidth,
        crosshairColor: custom && custom.length > 0 ? custom : input.fallbackCrosshairColor,
        candleUp: input.bullish,
        candleDown: input.bearish,
        // A1: per-direction grid. `undefined` is left undefined on purpose —
        // the engine reads a missing key as "visible", which is the legacy
        // behaviour, and a missing colour falls back to `gridColor`.
        gridVisible: input.vertGridVisible === undefined && input.horzGridVisible === undefined
            ? undefined
            : { vertical: input.vertGridVisible, horizontal: input.horzGridVisible },
        gridColorVertical: input.vertGridColor,
        gridColorHorizontal: input.horzGridColor,
    };
}
